"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterRulesSchema = void 0;
const zod_1 = require("zod");
const nestedFilterRule_1 = require("./nestedFilterRule");
const singleFilterRule_1 = require("./singleFilterRule");
exports.FilterRulesSchema = zod_1.z.object({
    rules: zod_1.z.array(singleFilterRule_1.SingleFilterRuleSchema.or(nestedFilterRule_1.NestedFilterRuleSchema)),
});
//# sourceMappingURL=filterRules.js.map